import { SSO_URL } from 'constants/auth';

export class SsoApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSsoUrlByDomainname(params) {
    return this.#http.get(SSO_URL, { params });
  }
}
